import meta from "./meta"

/**
 * Get number of sprint questions based on the subject and sprint number.
 * 
 * @param subject 
 * @param sprint 
 * @returns 
 */
export function getNofSprintQuestions(subject: string, sprint: number): number {
    let quantities = meta.quantities[subject.toLowerCase() as keyof typeof meta.quantities]
    if (typeof quantities === "number") {
        return quantities
    }
    let sprintInfo = quantities && quantities.find(info => info.sprint === sprint)
    return sprintInfo ? sprintInfo.questionCount : 0
}

/**
 * Get (extract) the sprint info from sprintId (timed-sprint test id)
 * 
 * @param sprintId <testType>-<subject>-<sprint> (ex: act-english-1)
 * @returns 
 */
export function getSprintInfo(sprintId: string) {
    let [testType, subject, sprint] = sprintId.split("-")
    return {
        testType,
        subject,
        sprint: Number(sprint)
    }
}
